import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@chakra-ui/react';
import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fieldName: string;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class FormFieldErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(`Error in ${this.props.fieldName} field:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <Box>
            <AlertTitle>Field Error</AlertTitle>
            <AlertDescription>
              There was an error loading the {this.props.fieldName} field.
              Please try refreshing the page or contact support if the issue persists.
            </AlertDescription>
          </Box>
        </Alert>
      );
    }

    return this.props.children;
  }
}
